import { Component, OnInit } from '@angular/core';
import { SUCURSALES} from '../../_config/strings';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-comisiones',
  templateUrl: './comisiones.component.html',
  styleUrls: ['./comisiones.component.scss']
})
export class ComisionesComponent implements OnInit {

  SUCURSALES: any;

  sucursales = [{
    id: '',
    nombre: ''
  }];

  currentSucursal = [{
    codSuc: '',
    codSeguridad: '',
    nombre: ''
  }];

  constructor(
    private router: Router
  ) {
    this.SUCURSALES = SUCURSALES;
  }

  ngOnInit() {
    this.sucursalesOnForm();
  }

  sucursalesOnForm () {
    this.sucursales = [];
    console.log( this.sucursales );
    for (const suc of this.SUCURSALES) {
      // console.log(suc);
      this.sucursales.push({
        id: suc.codSuc,
        nombre: suc.nombre
      });
    }
  }

  iniciarSesion () {
    const resultado = this.SUCURSALES.find( sucursal => sucursal.codSuc === this.currentSucursal[0].codSuc );
    if (resultado) {
      if (resultado.codSeguridad === this.currentSucursal[0].codSeguridad) {
        localStorage.setItem('sucursal_sesion', JSON.stringify( resultado ) );
        this.router.navigate(['dashboard/comisiones/formulario']);
      } else {
        Swal('¡Incorrecto!', 'Vuelve a introducir la contraseña', 'error');
      }
    } else {
        Swal('¡Incorrecto!', 'Ingresa los datos solicitados', 'error');
    }
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/comisiones/comisiones.component.ts